import { ReactNode, useEffect, useState, useMemo } from "react"
import { useSearchParams, useLocation, useNavigate } from "@/lib/router"

// HiddenGetParams context and hook
import { HiddenGetParamsContext, ControlStatus } from "./useHiddenGetParams"

/**
 * HiddenGetParamsProvider
 * @param param0
 * @returns
 */
export function HiddenGetParamsProvider({ children }: { children: ReactNode }) {
	// Router
	const location = useLocation()
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()

	// Params that we can capture
	const [nextGetParam, setNextGetParam] = useState<string>()
	const [controlStatusParam, setControlStatusParam] =
		useState<ControlStatus>()

	// When we have get params
	useEffect(() => {
		// Hide 'next' param from and store in context
		let nextGetParam = searchParams.get("next")?.replace(/^\/|$/g, "")
		if (nextGetParam) {
			setNextGetParam(nextGetParam)
			void navigate(location.pathname)
		}

		// Hide 'control_status' param from and store in context
		let controlStatusParam = searchParams
			.get("controlStatus")
			?.replace(/^\/|$/g, "")
		if (controlStatusParam) {
			setControlStatusParam(controlStatusParam as ControlStatus)
			void navigate(location.pathname)
		}
	}, [searchParams, location, navigate])

	return (
		<HiddenGetParamsContext.Provider
			value={{
				next: nextGetParam,
				controlStatus: controlStatusParam,
			}}
		>
			{useMemo(() => children, [children])}
		</HiddenGetParamsContext.Provider>
	)
}
